import { useEffect } from "react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import EnquiryForm from "@/components/EnquiryForm";

export default function RequestQuote() {
  useEffect(() => {
    document.title = "Request a Corporate Quote — THE GOOD GRID";
  }, []);

  return (
    <div data-testid="request-quote-page" className="bg-charcoal text-ivory min-h-screen pt-28 lg:pt-36 pb-24">
      <div className="px-4 sm:px-8 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-4">
          <Reveal><Eyebrow>Request a Quote</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h1 className="font-serif text-4xl sm:text-5xl mt-4 tracking-tight leading-[1.1]">
              Tell us the brief.<br /><span className="italic text-champagne-light">We'll do the rest.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-ivory/50 mt-6 text-sm leading-relaxed max-w-sm">
              Share your quantity, budget and occasion. Our gifting team responds with a curated proposal, corporate pricing and fulfilment plan.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 space-y-4 border-l border-champagne/40 pl-6">
              <p className="text-sm text-ivory/60">Response within one business day</p>
              <p className="text-sm text-ivory/60">No obligation — quotation first</p>
              <p className="text-sm text-ivory/60">Branding, packaging & fulfilment handled</p>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.2} className="border border-white/10 bg-[#161616] p-6 sm:p-10">
            <EnquiryForm />
          </Reveal>
        </div>
      </div>
    </div>
  );
}
